import {Component, Vue} from "vue-property-decorator";
import {CurrencyRepo} from "@services/repos/currencyRepo";
import { BitflowCurrencyRepo } from "@services/repos/bitflowCurrencyRepo";
import {_CONST} from "@/constants/constants";

@Component
export default class CurrencyMixin extends Vue {
  currencyRepo!: CurrencyRepo;
  bitflowCurrencyRepo!: BitflowCurrencyRepo;

  //------------------------------------------

  constructor() {
    super();
    this.currencyRepo = new CurrencyRepo();
    this.bitflowCurrencyRepo = new BitflowCurrencyRepo();
  }

  //------------------------------------------

  get _currencies(): any {
    return this.$store.getters['main/getCurrencies'];
  }
  set _currencies(val: any) {
    this.$store.commit('main/setCurrencies', val);
  }

  //------------------------------------------

  _currenciesRefresh() {
    return this.currencyRepo.getCurrencies()
        .then((res: any) => {
          if (!res.data) return;
          let currencies = res.data

          for (let i = 0; i < currencies.length; i++) {
            let currency = currencies[i]

            let currencyGateway = {...currency.currencyGateways[0]}
            if (currency.currencyGateways?.length > 1) {
              currencyGateway.isManyGateways = true
              currency.currencyGateways.forEach((x: any) => {
                if (x.depositEnabled) currencyGateway.depositEnabled = true
                if (x.withdrawalEnabled) currencyGateway.withdrawalEnabled = true
              })
            }

            currencies[i] = {
              ...currency,
              isManyGateways: currencyGateway.isManyGateways,
              gateway: currencyGateway.gateway,
              depositEnabled: currencyGateway.depositEnabled,
              depositFee: currencyGateway.depositFeeFixed,
              depositMinAmount: currencyGateway.depositMinAmount,
              withdrawalEnabled: currencyGateway.withdrawalEnabled,
              withdrawalFee: currencyGateway.withdrawalFee,
              withdrawalMinAmount: currencyGateway.withdrawalMinAmount,
            }
          }

          this._currencies = this._currenciesGetObjectFromArray(currencies)
        });
  }

  _currenciesGetObjectFromArray(val: [object]): any {
    let items: any = {};
    const currencyList: any = _CONST.currencyList;

    val.forEach((item: any) => {
      let currency: any = currencyList[item.id] || {}
      items[item.id] = {
        ...currency,
        ...item,
      };
    })

    return items;
  }

  _currenciesGetArray(): any {
    let items: any = [];
    for (let key in this._currencies) {
      const currency = this._currencies[key]
      items.push({...currency});
    }
    return items;
  }

  _currencyGetAddrExplorer(currency: any, gateway: any, address: any) {
    let currencyData = this._currencies[currency]
    if(!currencyData) return null
    let gatewayInfo = currencyData.currencyGateways.find((x : any) => x.gateway === gateway || x.id === gateway)
    if(!gatewayInfo?.blockExplorerAddressUriTemplate) return null
    return gatewayInfo.blockExplorerAddressUriTemplate.replace("{Address}", address)
  }

  _currencyGetTxExplorer(currency: any, gateway: any, tx: any) {
    let currencyData = this._currencies[currency]
    if(!currencyData) return null
    let gatewayInfo = currencyData.currencyGateways.find((x: any) => x.gateway === gateway || x.id === gateway)
    if(!gatewayInfo?.blockExplorerTxUriTemplate) return null
    return gatewayInfo.blockExplorerTxUriTemplate.replace("{Txid}", tx)
  }
}
